"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLocationActive = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MapLocationActive = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "map-location-active", viewBox: "0 0 24 24", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "map-location-active", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19.5 9.214c0 1.366-.424 2.64-1.155 3.716a1.194 1.194 0 0 1-.137.29l-5.09 7.938c-.506.79-1.73.79-2.237 0L5.792 13.22a1.2 1.2 0 0 1-.137-.291A6.574 6.574 0 0 1 4.5 9.214C4.5 5.368 7.858 2.25 12 2.25c4.142 0 7.5 3.118 7.5 6.964ZM12 12a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", fillRule: "evenodd" }) })) })));
};
exports.MapLocationActive = MapLocationActive;
